module.exports = __webpack_public_path__ + "static/img/folia.8a6a0923.png";